<template>
  <el-card>
    <!-- 查询表单 -->
    <el-form :inline="true" :model="searchFactor" class="search-form">
      <el-form-item label="主题:" >
        <el-input v-model="searchFactor.theme"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleCreateNotice">创建</el-button>
      </el-form-item>
    </el-form>
    <!-- 数据表格 -->
    <el-table
      :data="tableData"
      :stripe ="true"
      :border = "true"
      height="calc(100vh - 200px)"
      max-height="calc(100vh - 200px)"
      :highlight-current-row ="true"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}"
      style="width: 100%">
      <el-table-column
        type="index"
        label="序号"
        :index="indexMethod">
      </el-table-column>
      <el-table-column
        prop="theme"
        label="主题"
        width="300" >
      </el-table-column>
      <el-table-column
        prop="content"
        label="内容"
        min-width="300"
         :formatter="formatContent">
      </el-table-column>
      <el-table-column
        prop="initFolderName"
        label="资源文件夹"
        width="150">
      </el-table-column>
      <el-table-column
        prop="attachFileName"
        label="附件名称"
        width="200">
      </el-table-column>
      <el-table-column
      prop="active"
      width="70"
      label="状态" >
      <template slot-scope="scope">
        <span v-if = "scope.row.active == 0" style="color: red"> 未发布</span>
        <span v-else style="color: greenyellow" > 已发布</span>
      </template>
      </el-table-column>
      <el-table-column
        prop="createUser"
        label="创建者"
        width="120">
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        width="100">
      </el-table-column>
      <el-table-column label="操作" min-width="120px">
        <template slot-scope="scope" >
          <el-dropdown split-button type="primary" @command="handleCommand">
            管理
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item divided :command = '{event:"doActiveNotice",index:scope.$index, data:scope.row}'>
                <i :class="scope.row.active == 0 ? 'el-icon-star-on':'el-icon-star-off' "  :style="scope.row.active == 0 ?'color:rgb(40, 238, 10)' :'color:rgb(246, 102, 18)'" ></i> 
                <span>{{scope.row.active == 0?'发布':'撤销'}}</span>
              </el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"handleViewNotice",index:scope.$index, data:scope.row}'> <i class="el-icon-search" style="color:rgb(39, 193, 231)" ></i> <span>预览</span></el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"handleEditNotice",index:scope.$index, data:scope.row}'><i class="el-icon-edit" style="color:rgb(41, 10, 239)" ></i> <span>编辑</span></el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"uploadAttach", index:scope.$index,data:scope.row}'><i class="el-icon-upload2" style="color:rgb(40, 238, 10)" ></i> <span>上传附件</span></el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"handleDeleteAttach",index:scope.$index, data:scope.row}'><i class="el-icon-delete" style="color:rgb(247, 33, 40)" ></i> <span>删除附件</span></el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"handleDelete", index:scope.$index,data:scope.row}'><i class="el-icon-delete-solid" style="color:rgb(246, 102, 18)" ></i> <span>删除</span></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页插件 -->
    <el-pagination style="margin:10px"
      background
      layout="total,prev, pager, next"
      @current-change="handleCurrentChange"
      :page-size="pager.pageSize"
      :total="pager.totalCount">
    </el-pagination>
    <!-- 创建通知公告主题弹框 -->
    <el-dialog width="40%" :visible.sync="dialogVisual.initNoticeThemeVisual" v-on:close ="clearInitNoticeForm" >
      <div slot="title" class="dialog-footer">
        <span> 创建通知公告主题 </span>
      </div>
      <el-form :model="initNoticeForm"  label-width="20%">
        <el-form-item  label="主题:" style="width:90%">
          <el-input v-model="initNoticeForm.theme"  autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ensureCreate">创建</el-button>
      </div>
    </el-dialog>

    <!-- 上传附件弹框 -->
    <el-dialog width="40%" :visible.sync="dialogVisual.initUploadAttachVisual" v-on:close ="clearUplaodAttachForm" >
      <div slot="title" class="dialog-footer">
        <span> 上传附件 </span>
      </div>
      <el-upload
        style="display: inline-block"
        ref='uploadAttach'
        :action="noticeAttach.url"
        :headers="noticeAttach.headers"
        :multiple="false"
        :limit="noticeAttach.limit"
        :name="noticeAttach.file"
        :on-success="fileUpLoadSuccess"
        :show-file-list="true"
        :on-error="fileUpLoadError">
        <el-button  size="mini"  @click="handleUploadAttach()">添加附件</el-button>
      </el-upload>
    </el-dialog>
  </el-card>
</template>                     
<script>
  // 引入组件
import axios from  '@/api/axiosConfig'
import SERVICE_URL  from  '@/api/url'
import {stringIsNullOrEmpty,getToken} from  '@/api/utils'
import {PAGE_SIZE,MESSAGE_DURATION,fileType,fileAreaType} from  '@/api/constant'
export default {
  name : 'pc_ctr_notice_list',
  data() {
    return {
      searchFactor: {
        theme: ''
      },
      dialogVisual:{
        initNoticeThemeVisual: false,
        initUploadAttachVisual:false
      },
      initNoticeForm:{
        theme:''
      },
      noticeAttach :{
        headers: {token:""},
        url : "",
        limit : 1,
        name :"file",
        id :""
      },
      tableData: [],
      pager:{
        totalCount:0,
        pageSize : PAGE_SIZE
      }
    }
  },
  methods : {
    handleCommand(command){
      let index  = command.index
      let row = command.data
      let event = command.event
      switch(event){
        case 'handleDelete' :
            this.handleDelete(index,row)
            break
        case 'handleDeleteAttach' :
            this.handleDeleteAttach(index,row)
            break
        case 'handleEditNotice' :
            // this.handleEditNotice(index,row)
            let left =  (window.screen.availWidth-10-1000)/2
            let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
            width=1000,height=1000,left=${left},top=100`;
            window.open(SERVICE_URL+"/#/pc_ctr_notice_edit/" +row.id,"test",params);
            break
        case 'handleViewNotice':
            //this.handleViewNotice(index,row)
            // this.handleEditNotice(index,row)
            let left0 =  (window.screen.availWidth-10-1000)/2
            let params0 = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
            width=1000,height=1000,left=${left0},top=100`;
            window.open(SERVICE_URL+"/#/pc_ctr_editor_view/" +row.id +"?fileType=" + fileType.NOTICE_FILE,"通知公告预览",params0);
            break
        case 'doActiveNotice':
            this.doActiveNotice(index,row)
            break
        case 'uploadAttach':
            this.uploadAttach(index,row)
            break
      }
    },
    uploadAttach(index,row){
      this.dialogVisual.initUploadAttachVisual = true
      this.noticeAttach.id = row.id
    },
    indexMethod(index){
      return  index + 1
    },
    handleUploadAttach(){
      this.noticeAttach.url = "/bc/exa/notice/upload?id=" + this.noticeAttach.id + "&fileArea="+  fileAreaType.ATTACH
    },
    fileUpLoadSuccess(response, file, fileList){
      this.$refs.uploadAttach.clearFiles();
      if(response.code === 0){
        this.dialogVisual.initUploadAttachVisual
        this.$message({
          showClose: true,
          message: '上传成功!',
          type: 'success',
          duration: MESSAGE_DURATION
        })
      }else{
        this.$message({
          showClose: true,
          message: response.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      }
    },
    fileUpLoadError(err, file, fileList){
      this.$refs.uploadAttach.clearFiles();
      this.$message({
        showClose: true,
        message: err,
        type: 'error',
        duration: MESSAGE_DURATION
      })
    },
    formatContent(row , index){
      if(row.content == null || row.content == ''){
        return ''
      }
      if(row.content.length > 400 ){
        return row.content.substring(0,400)
      }
      return row.content
    },
    handleCurrentChange(val){
      this.noticeListLoad(val);
    },
    noticeListLoad(pageNo){
      let url = "/bc/exa/notice/noticePage"
      let { 
          theme
      } = this.searchFactor 
      let dat0 = {
          pageSize: PAGE_SIZE,
          theme,
          pageNo
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data;
          if(dat.data.length !== 0){
              this.tableData = [];
              dat.data.forEach(t=>this.tableData.push(t))
              this.pager.totalCount = dat.totalDataCount;
          } else {
            this.$message({
              showClose: true,
              message: '未查询到通知信息！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch((err)=>{
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        });
    },
    onSearch(){
      this.noticeListLoad(1)
    },
    handleCreateNotice(){
      this.dialogVisual.initNoticeThemeVisual = true
    },
    handleViewNotice(index, row){
      this.$router.replace({ path:'pc_ctr_notice_view', query: {id: row.id}} )
    },
    handleDelete(index, row){
      this.$confirm('即将删除主题['+row.theme+']的通知公告!', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doDeleteNotice(row)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消删除！'
        });
      })
    },
    doDeleteNotice(row){
      let datBat = {id: row.id}
      let url = "/bc/exa/notice/noticeDelete"
      let s = JSON.stringify(datBat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.$message({
            showClose: true,
            message: '删除成功!',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          this.noticeListLoad(1);
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    handleDeleteAttach(index, row){
      this.$confirm('即将删除主题['+row.theme+']的附件!', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doDeleteNoticeAttach(row)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消删除！'
        });
      })
    },
    doDeleteNoticeAttach(row){
      let dat = {id: row.id}
      let url = "/bc/exa/notice/deleteAttach"
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.$message({
            showClose: true,
            message: '删除成功!',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          this.noticeListLoad(1);
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    doActiveNotice(index,row){
      let actState = row.active === 0 ? 1 : 0
      let dat = {
        id: row.id,
        active: actState
      }
      let url = "/bc/exa/notice/noticeActive"
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.$message({
            showClose: true,
            message: '操作成功!',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          this.noticeListLoad(1);
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    handleEditNotice(index,row){
      this.$router.replace({ path:'pc_ctr_notice_change',query: {id: row.id, fileType : fileType.NOTICE_FILE} })
    },
    ensureCreate(){
      let theme = this.initNoticeForm.theme.trim();
      try{ 
        stringIsNullOrEmpty(theme,'请输入主题!');
      }catch (e){
        this.$message({
          showClose: true,
          message: e,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
        return
      }
      let dat = {
        theme : theme
      }
      let url = "/bc/exa/notice/save"
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.dialogVisual.initNoticeThemeVisual = false;
          this.$message({
            showClose: true,
            message: '初始化通知公告成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          this.clearInitNoticeForm();
          this.noticeListLoad(1);
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err)=> {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    clearInitNoticeForm(){
      this.initNoticeForm.theme = ''
    },
    clearUplaodAttachForm(){
      this.noticeAttach.id = ''
      this.noticeAttach.url= ""
    }
  },
  created () {
    setTimeout(()=>{getToken(this.noticeAttach.headers)},200)
    this.noticeListLoad(1);
  }
}
</script>

<style lang="less" scoped>
.el-card {
  height: 99%
}

.search-form{
  margin-top: 10px;
  text-align:left 
}
</style>



// WEBPACK FOOTER //
// src/pc_pages/pc_ctr_component/pc_ctr_notice_list.vue